import React from "react";
import { useTranslation } from "react-i18next";
import type { AddRateComponentFormFields } from "@sinch/components/application/RateComponent/formSchema";
import { TextInput, useMuiController } from "@sinch/components/index";

export const ComponentCode = () => {
  const { t } = useTranslation();
  const { field } = useMuiController<AddRateComponentFormFields>({
    name: "code",
  });
  return (
    <TextInput
      {...field}
      inputProps={{ "data-cy": "ComponentForm-code-input" }}
      label={t("RateBuilder.addComponentCode")}
      placeholder={t("enterPlaceholder", {
        inputName: (t("RateBuilder.addComponentCode") as string).toLowerCase(),
      })}
      required
    />
  );
};
